import React from 'react';
import PropTypes from 'prop-types';

export default function RegisterIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path
        fill={fill}
        d='M4.892 3v5.784H2v7.75a2 2 0 0 0 2 2h12.955a2 2 0 0 0 2-2V3Zm0 12.811h-1.07V9.854h1.07Zm2.892-9.919h3.962v3.962H7.784Zm0 5.755H10.3v1.07H7.784Zm8.271 3.962h-8.3v-1.07h8.3Zm0-2.863h-3.962v-1.07h3.962Zm0-2.892h-2.516v-1.07h2.516Zm0-2.892h-2.516v-1.07h2.516Z'
        data-name='Caminho 103143'
      />
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
    </svg>
  );
}

RegisterIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

RegisterIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
